import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "pviews__head" }
const _hoisted_2 = { class: "pviews__meta" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "pviews__pick"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 1,
  class: "pviews__summary",
  "data-tour": "product-views-summary"
}
const _hoisted_8 = {
  key: 2,
  class: "pviews__guide"
}
const _hoisted_9 = {
  key: 3,
  class: "pviews__guide"
}
const _hoisted_10 = { class: "pviews__actions" }

import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductViewsInsightModal',
  props: {
    productCode: {},
    productName: {},
    views: {},
    soldCount: {},
    candidates: { default: () => [] }
  },
  emits: ["close", "preview", "select"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const titleId = `pviews-${Math.random().toString(36).slice(2, 7)}`
const panelEl = ref<HTMLElement | null>(null)

const conversionLabel = computed(() => {
  const views = Math.max(0, Number(props.views) || 0)
  const sold = Math.max(0, Number(props.soldCount) || 0)
  if (views <= 0) return sold > 0 ? '—' : '0%'
  return `${Math.round((sold / views) * 1000) / 10}%`
})

function onPick(event: Event) {
  emit('select', (event.target as HTMLSelectElement).value)
}

function onKey(event: KeyboardEvent) {
  if (event.key === 'Escape') emit('close')
}

onMounted(async () => {
  document.addEventListener('keydown', onKey)
  await nextTick()
  panelEl.value?.focus()
})

onUnmounted(() => {
  document.removeEventListener('keydown', onKey)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "pviews",
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": titleId,
    onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (emit('close')), ["prevent"]), ["esc"]))
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "pviews__catch",
      "aria-label": "닫기",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
    }),
    _createElementVNode("div", {
      class: "pviews__panel",
      tabindex: "-1",
      ref_key: "panelEl",
      ref: panelEl
    }, [
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", { id: titleId }, "조회 · 전환"),
          _createElementVNode("p", _hoisted_2, [
            _createElementVNode("strong", null, _toDisplayString(__props.productName || '상품을 선택하세요'), 1),
            (__props.productCode)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.productCode), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "pviews__close",
          "aria-label": "조회 닫기",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
        }, [
          _createVNode(AppIcon, {
            icon: "mdi-close",
            size: 20
          })
        ])
      ]),
      (__props.candidates.length)
        ? (_openBlock(), _createElementBlock("label", _hoisted_4, [
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "상품", -1)),
            _createElementVNode("select", {
              class: "sui-input",
              value: __props.productCode,
              onChange: onPick
            }, [
              _cache[5] || (_cache[5] = _createElementVNode("option", { value: "" }, "상품을 선택하세요", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.candidates, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item.code,
                  value: item.code
                }, _toDisplayString(item.name), 9, _hoisted_6))
              }), 128))
            ], 40, _hoisted_5)
          ]))
        : _createCommentVNode("", true),
      (__props.productCode)
        ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
            _createElementVNode("div", null, [
              _cache[7] || (_cache[7] = _createElementVNode("span", null, "조회수", -1)),
              _createElementVNode("strong", null, _toDisplayString(__props.views.toLocaleString('ko-KR')), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[8] || (_cache[8] = _createElementVNode("span", null, "누적 판매", -1)),
              _createElementVNode("strong", null, _toDisplayString(__props.soldCount.toLocaleString('ko-KR')) + "개", 1)
            ]),
            _createElementVNode("div", null, [
              _cache[9] || (_cache[9] = _createElementVNode("span", null, "조회→구매", -1)),
              _createElementVNode("strong", null, _toDisplayString(conversionLabel.value), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.productCode)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, " 조회수는 구매자가 몰 상품 상세를 연 횟수입니다. 판매는 입금 확인된 수량입니다. 조회는 많은데 판매가 적으면 가격·썸네일·상세를 점검해 보세요. "))
        : (_openBlock(), _createElementBlock("p", _hoisted_9, "상품을 고르면 조회수와 판매, 조회에서 구매로 이어진 비율이 나옵니다.")),
      _createElementVNode("footer", _hoisted_10, [
        _createElementVNode("button", {
          type: "button",
          class: "sui-btn sui-btn--ghost",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
        }, "닫기"),
        (__props.productCode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "sui-btn sui-btn--primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('preview')))
            }, " 몰 미리보기 "))
          : _createCommentVNode("", true)
      ])
    ], 512)
  ], 32))
}
}

})